export const LANG_WebShop_NAME = 'webshop';

export const LANG_WebShop_TRANS = {
    'medlemskap': 'Ett års medlemskap i Norsk Familiehistorie',
    'slektogdata':'Slektogdata',
    'historielag':'Historielag',
    'versjon10':'Versjon 10 av Embla Familie og Slekt',
    'versjon10ogmedlemskap':'Versjon 10 av Embla Familie og Slekt + ett års medlemskap i Norsk Familiehistorie'
};


// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/translate/lang-webshop.ts